export default __webpack_public_path__ + "static/media/404error.e6c74189.svg";